import { createReducer, on } from "@ngrx/store";
import { AuthorizeActions } from "../actions";

export const authorizeKey = 'authorize';

export interface State {
  accessFunctions: { [id: string]: boolean; },
  authorizeCallSuccess: boolean,
  authorizeCallFailure: boolean
}

export const initialAuthorizeState: State = {
  accessFunctions: {},
  authorizeCallSuccess: false,
  authorizeCallFailure: false
}

export const authorizeReducer = createReducer(
  initialAuthorizeState,
  on(AuthorizeActions.authorizeSuccess, (_state, action) => {
    return {
      accessFunctions: action.accessFunctions,
      authorizeCallSuccess: true,
      authorizeCallFailure: false
    }
  }),
  on(AuthorizeActions.authorizeFailed, (_state, action) => {
    return {
      accessFunctions: action.accessFunctions,
      authorizeCallSuccess: false,
      authorizeCallFailure: true
    }
  })
);